import { apiHolder, apis } from 'api';
import { debounceRequest } from '@web-mail/utils/debounceRequest';
const salesPitchApi = apiHolder.api.requireLogicalApi(apis.salesPitchApiImpl);
const debounceReqDataGroupWarp = debounceRequest();
const debounceReqConfigGroupWarp = debounceRequest();
const debounceReqSortGroupWarp = debounceRequest();
const getSalesPitchData = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG
    ? () => { }
    : debounceReqDataGroupWarp(salesPitchApi.getSalesPitchData.bind(salesPitchApi));
const getSalesPitchConfig = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG
    ? () => { }
    : debounceReqConfigGroupWarp(salesPitchApi.getSalesPitchConfig.bind(salesPitchApi));
const getLocalSalesPitchConfig = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG ? () => { } : salesPitchApi.getLocalSalesPitchConfig.bind(salesPitchApi);
const setSalesPitchConfig = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG ? () => { } : salesPitchApi.setSalesPitchConfig.bind(salesPitchApi);
const setLocalSalesPitchConfig = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG ? () => { } : salesPitchApi.setLocalSalesPitchConfig.bind(salesPitchApi);
const addSalesPitch = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG ? () => { } : salesPitchApi.addSalesPitch.bind(salesPitchApi);
const editSalesPitch = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG ? () => { } : salesPitchApi.editSalesPitch.bind(salesPitchApi);
const searchSalesPitch = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG ? () => { } : salesPitchApi.searchSalesPitch.bind(salesPitchApi);
const sortSalesPitch = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG
    ? () => { }
    : debounceReqSortGroupWarp(salesPitchApi.sortSalesPitch.bind(salesPitchApi));
const deleteSalesPitch = process.env.BUILD_ISLINGXI_WITHOUT_LINGHANG ? () => { } : salesPitchApi.deleteSalesPitch.bind(salesPitchApi);
export const salesPitchRequest = {
    getSalesPitchData,
    getSalesPitchConfig,
    getLocalSalesPitchConfig,
    setSalesPitchConfig,
    setLocalSalesPitchConfig,
    addSalesPitch,
    editSalesPitch,
    searchSalesPitch,
    sortSalesPitch,
    deleteSalesPitch,
};
